<template>
  <span>
    <i class="fa fa-fw fa-sort" v-show="!order"></i>
    <i class="fa fa-fw fa-sort-asc" v-show="'asc' === order"></i>
    <i class="fa fa-fw fa-sort-desc" v-show="'desc' === order"></i>
  </span>
</template>

<script>
  export default {
    name: 'sorter-icon',
    props: {
      order: {
        type      : String,
        default   : null,
        validator : value => ['asc', 'desc'].indexOf(value) !== -1
      }
    }
  }
</script>
